import { render, staticRenderFns } from "./bulkUploadProduct.vue?vue&type=template&id=45cc94ae&"
import script from "./bulkUploadProduct.vue?vue&type=script&lang=js&"
export * from "./bulkUploadProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports